export default __webpack_public_path__ + "assets/0d8cb90b1a4484b786513a42bdfc5ab8.png";